module.exports = __webpack_public_path__ + "static/media/logo-dark.cc94c938.png";